<template>
  <div v-if="rows.length" class="box py-2 chat-work-history" dir="rtl" data-test="chat-work-history">
    <p class="has-text-weight-bold mb-1">היסטוריית תעסוקה (מהצ'אט)</p>
    <ul class="is-size-7">
      <li v-for="(row, i) in rows" :key="i" data-test="chat-work-history-row">
        <span v-if="row.internship" class="tag is-light is-info is-small ml-1" data-test="internship-tag">התמחות</span>
        <span>{{ row.text }}</span>
        <span v-if="row.period" class="has-text-grey"> · {{ row.period }}</span>
        <span v-if="row.source" class="has-text-grey-light"> · מקור: {{ row.source }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { monthYear, sourceLabel } from './chat_labels'

// VA2 - read-only work history the chatbot collected (applicant.work_history).
export default {
  name: 'ChatWorkHistory',
  props: {
    workHistory: { type: Array, default: () => [] }
  },
  computed: {
    rows () {
      return (Array.isArray(this.workHistory) ? this.workHistory : [])
        .filter(r => r && (r.company || r.role))
        .map(r => {
          const start = monthYear(r.start)
          const end = r.current ? 'היום' : monthYear(r.end)
          return {
            internship: r.kind === 'internship',
            text: [r.role, r.company].filter(Boolean).join(' · '),
            period: start || end ? `${start || '?'}–${end || '?'}` : '',
            source: sourceLabel(r.source)
          }
        })
    }
  }
}
</script>

<style scoped>
.chat-work-history ul { margin: 0; }
.chat-work-history li { line-height: 1.6; }
</style>
